import React, { Fragment } from 'react'
import { Col } from 'reactstrap'
import { ContainerLg } from '../../../GlobalStyles'
import styled, { createGlobalStyle } from 'styled-components'
import StepsCard from '../StepsCard'
import { StaticQuery, graphql } from 'gatsby'
import steps from './steps'

const GlobalStyle = createGlobalStyle`
  .stages-lg {
    > div{
      height: 340px;
      @media (max-width: 1024px) {
        height: auto;
        img{
          width: 100%;
          height: auto;
          top: 100%;
        }
      }
    }
  }
  .mobile-hiddden{
    @media (max-width: 1024px) {
        display: none;
    }
  }
`

export const StagesCol = styled(Col)`
  &:last-of-type{
    > div:last-of-type {
      height: 340px;
      @media (max-width: 1024px) {
        height: auto;
        img{
          width: 100%;
          height: auto;
          top: 100%;
        }
      }
  }
`

const StagesSetWrapper = styled.div`
  width: 100%;
`

export const TextContainer = styled.div`
  padding: 0 20px;
  text-align: center;
  color: ${p => p.theme.colors.blueGray};
  margin-bottom: 20px;
`

const StepsSet = props => (
  <StaticQuery
    query={graphql`
      query {
        steps: allMarkdownRemark(
          sort: { fields: [frontmatter___number], order: ASC }
          filter: { fileAbsolutePath: { regex: "/stage/" } }
        ) {
          edges {
            node {
              excerpt
              frontmatter {
                date(formatString: "DD MMMM, YYYY")
                title
                number
                stagesLine1
                stagesLine2
                style
                extraImage {
                  ...optimizedSharpSizes
                }
                featuredImage {
                  ...optimizedSharpSizes
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <Fragment>
        <div id='seven-stages'>
          <StagesSetWrapper>
            <ContainerLg>
              {steps.map((item, idx) => (
                <StepsCard {...item} reverse={idx % 2 === 0} />
              ))}
            </ContainerLg>
          </StagesSetWrapper>
          <GlobalStyle />
        </div>
      </Fragment>
    )}
  />
)

export default StepsSet
